import { httpCreate } from './http';
import config from '@services/config';
import QueryString from 'qs';

const http = httpCreate('/um/fission-activity');

export const fissionActivity = {
	/** 创建活动
	 * @param { String } data.title 活动名称
	 * @param { String } data.banner banner
	 * @param { String } data.detail 详情
	 * @param { Array } data.detailImages 详情图片
	 * @param { Number } data.endTime 截止时间
	 * @returns
	 */
	createActivity(data) {
		return http.post('', data);
	},
	/** 更新活动
	 * @param { Number } id 活动ID
	 * @param { String } data.title 活动名称
	 * @param { String } data.banner banner
	 * @param { String } data.detail 详情
	 * @param { Number } data.activityId 关联直播间ID
	 * @param { Array } data.detailImages 详情图片
	 * @param { Number } data.endTime 截止时间
	 * @returns
	 */
	updateActivity(id, data) {
		return http.put(`/${id}`, data);
	},
	/** 获取活动列表
	 * @param { Number } params.pageNum 页码
	 * @param { Number } params.pageSize 页容量
	 * @param { String } params.title 搜索标题
	 * @returns
	 */
	getList(params) {
		return http.get('/page', { params });
	},
	// 获取活动详情
	getFissionInfo(fissionId) {
		return http.get(`/${fissionId}`);
	},
	// 获取绑定码
	getGroupBindCode(fissionId) {
		return http.get(`/group-code/${fissionId}`);
	},
	/**	开启，关闭活动
	 * @param { Number } fissionId 活动ID
	 * @param { Number } openStatus 开启状态： 0 关闭 1 开启
	 */
	changeOpenStatus(fissionId, openStatus) {
		return http.put(`/${fissionId}/open/${openStatus}`);
	},
	/** 轮询绑定状态
	 * @param { String } params.bindCode
	 * @returns
	 */
	getGroupBindStatus(params) {
		return http.get('/group-code/status', { params });
	},

	/** 获取群聊列表
	 * @param { Number } params.nickname 昵称
	 * @param { Number } params.inviteNickname 邀请人昵称
	 * @param { String } params.status 状态 0 退群 1 正常 不传全部
	 * @param { Number } params.pageNum 页码
	 * @param { Number } params.pageSize 页容量
	 * @param { Number } params.groupId 所属群组
	 * @returns
	 */
	getMemberList(fissionId, params) {
		return http.get(`/${fissionId}/member/page`, { params });
	},

	// 删除活动
	deleteFission(fissionId) {
		return http.delete(`/${fissionId}`);
	},
	/** 导出群成员列表
	 * @param { Number } fissionId 活动ID
	 * @param { Number } params.nickname 昵称
	 * @param { Number } params.inviteNickname 邀请人昵称
	 * @param { String } params.status 状态 0 退群 1 正常 不传全部
	 * @param { Number } params.groupId 所属群组
	 * @returns
	 */
	exportFile(fissionId, params) {
		const query = QueryString.stringify(params);
		return `${config.host}/um/fission-activity/${fissionId}/member/export${query ? '?' + query : ''}`;
	},
};
